import { render, staticRenderFns } from "./marketSegment.vue?vue&type=template&id=19b95df4&scoped=true"
import script from "./marketSegment.vue?vue&type=script&lang=js"
export * from "./marketSegment.vue?vue&type=script&lang=js"
import style0 from "./marketSegment.vue?vue&type=style&index=0&id=19b95df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b95df4",
  null
  
)

export default component.exports